{
  "code": "Invitation code",
  "error": {
    "details": "<ul><li>Check for any typos and try again.</li><li>If you’re stuck, call us on {{phone}} (press Option 2).</li></ul>",
    "title": "That invitation code didn’t work"
  },
  "helpMessage": "<p>Lost your invite or unsure what to do?<br />Please call us on <a><strong>{{phone}}</strong></a> (then press <strong>Option 2</strong>).</p>",
  "text": "<p>Enter your 6-character invitation code to get started.</p><p>You’ll find this code in your email invitation, or it may have been given to you by your referrer.</p>",
  "title": "Access your booking invitation"
}
